import { getFetcher } from "@/services/global";
import useSWR from "swr";

export function useCheckIfAuth(isLoggedIn, fetchCheckIfAuth) {
  const res = useSWR(
    () =>
      isLoggedIn && fetchCheckIfAuth ? `/api/header/checkifauth` : null,
    getFetcher,
    {
      revalidateOnMount: 10 * 60 * 1000, // 10 minutes in milliseconds
      revalidateOnFocus: false,
    }
  );

  if (
    isLoggedIn &&
    res?.data == undefined &&
    fetchCheckIfAuth &&
    !res?.isLoading
  ) {
    return "remove mage";
  } else {
    return "not remove mage";
  }
}
